import { useStore } from 'react-redux';
import { useContext, useCallback } from 'react'
import { GridBoundaryAdjustmentContext, ColumnResizeContext, CellResizeContext } from './Contexts';
import { DragInterfaceContext } from './MouseDragProvider';
import { GRID_COLUMN_RESIZE_Z_INDEX } from './UIConstants';
import G from './Getters';
import computeNewCellWidths from './computeNewCellWidths';

export default function ResizeElement({
  side,
  resizeFrom,
  figurePanelId,

  leftResize,
  cell,
  cellResizeInfo,
  setDontUnselectCells,
  cellX,
  w,
  widths
}){

  let width = resizeFrom === "inside" ? 3 : 4;

  let sidePosition = 0;//resizeFrom === "inside" ? -width/2 : 0;
  



  const { setCellResizeInfo } = useContext(CellResizeContext);

  const { columnResizeInfo, setColumnResizeInfo, setCurrentWidths } = useContext(ColumnResizeContext);

  //const { setAdjustmentSideContext, adjustmentSide } = useContext(GridBoundaryAdjustmentContext);

  let adjustmentSide = columnResizeInfo?.cellSide;

  const dic = useContext(DragInterfaceContext);
  let { startDrag } = dic;


  let store = useStore();

  const cellString = cell.y + '-' + cell.x;

  const style  = {
        position:'absolute',
        [side]:sidePosition,
        top:0,height:'100%',
        
        background: (
          cellResizeInfo?.leftResize !== true && 
          cellResizeInfo?.cellX===(cell.x+cell.w-1)?'blue':undefined),
        width,
        cursor:'ew-resize',
        zIndex:GRID_COLUMN_RESIZE_Z_INDEX,

      }

  const onMouseEnter = () => {

      let cellCoords = [cell.y,cell.x]

      let state = store.getState();

      let resizeInfo = G.getCellResizeInfo(state,{
        figurePanelId,
        cell:cellCoords,
        cellSide:side,
        resizeFrom
      })
      setCellResizeInfo && setColumnResizeInfo({ cell:cellCoords, resizeFrom, 
        cellSide:side, ...resizeInfo 
      })
  }



  const onMouseLeave = () => {
    setCellResizeInfo && setColumnResizeInfo();
  }
  

  const onMouseDown = useCallback(e=> {

    //console.log("MOUSEDOWN PROP WIDTS",widths)

    let cellCoords = [cell.y,cell.x]

    if( e.button !== 0 ){
      return;
    }

    startDrag({
      event:e,

      onMouseMove:(start,end, info) => {

        let { leftResize, impactedRanges } = info;

        let delta = end[0] - start[0];

        if( leftResize && impactedRanges.length === 1){
          //everything is backwards if done from the left

          delta *= -1
        }


        let computedCellWidths = computeNewCellWidths({
          info:columnResizeInfo,
          delta,
          widths,
          //currentWidths
        })


        console.log("computed",computedCellWidths);

        setCurrentWidths(computedCellWidths)



      },

      type:"cellResizeInfo",
      cell:cellCoords,
      cellX,
      cellXList:Array(w).fill(cell.x).map((x,ii) => x+ii),
      startX:e.clientX,
      currentX:e.clientX,
      leftResize:(side==="left" && resizeFrom==="inside"),
      side,
      ...columnResizeInfo,
    })


    setCellResizeInfo({
      cell:[cell.y,cell.x],
      cellX,
      cellXList:Array(w).fill(cell.x).map((x,ii) => x+ii),
      startX:e.clientX,
      currentX:e.clientX,
      leftResize:(side==="left" && resizeFrom==="inside")
    })
  },
    [
      columnResizeInfo,
      setCurrentWidths,
      w,
      widths,
    ]
  );

  return (
    <div 
      objectType={"ResizeElement"}
      cell={cellString}
      resizeElement={side}
      class=" blue-hoverable cell-width-resizer-element"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseDown={onMouseDown}
      onClick={stopProp}
      onContextMenu={prevDef}
      style={style}>
    </div>
  )

}

const stopProp = e => e.stopPropagation();
const prevDef = e => e.preventDefault();
